$(document).ready(function(){
	$('.tab__link').on('click', function(){
		var tab = $(this).attr('data-tab');
		// -- links --
		$('.tab__link').removeClass('active');
		$(this).addClass('active');
		// -- content --
		$('.tab__content').removeClass('active');
		$('.tab__content.'+tab).addClass('active');
		// -- start scroll for animation-element --
		$('html, body').animate({
			scrollTop: $(window).scrollTop() + 1
		}, 'fast');

	});
});